/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICusRecommendedProducts contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum recommendationType {
    mostViewed = 'mostViewed',
    mostPurchased = 'mostPurchased',
    recentlyViewed = 'recentlyViewed',
    personalized = 'personalized'
}

export const enum relevanceModifier {
    boostDiscounted = 'boostDiscounted'
}

export const enum displayLocation {
    landingPage = 'landingPage',
    myAccount = 'myAccount'
}

export interface ICusRecommendedProductsConfig extends Msdyn365.IModuleConfig {
    recommendationType: recommendationType;
    productCount: number;
    relevanceModifier?: relevanceModifier;
    title: string;
    displayLocation: displayLocation;
    className?: string;
    clientRender?: boolean;
    categoryRecordId?: number;
    relevanceModifierStrength?: number;
}

export interface ICusRecommendedProductsResources {
    recommendedProductsCtaLabel: string;
}

export interface ICusRecommendedProductsProps<T> extends Msdyn365.IModule<T> {
    resources: ICusRecommendedProductsResources;
    config: ICusRecommendedProductsConfig;
}
